import { render, staticRenderFns } from "./ProductsTable.vue?vue&type=template&id=aa4efe20&scoped=true"
import script from "./ProductsTable.vue?vue&type=script&lang=js"
export * from "./ProductsTable.vue?vue&type=script&lang=js"
import style0 from "./ProductsTable.vue?vue&type=style&index=0&id=aa4efe20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4efe20",
  null
  
)

export default component.exports